export default __webpack_public_path__ + "static/media/30_3_1.6d814af0.png";